module.exports = __webpack_public_path__ + "static/media/insect(7).32c3d376.PNG";